export default "__VITE_ASSET__CW71R0Le__"